import {
  constructPlannerEventHref,
  routePaths,
} from "../../../../../common/infrastructure/routes/routePaths";

interface IClassWizardSavedRouteArgs {
  savedEventId: number;
  appliedToFuture: boolean;
  employeeId?: number | null;
  currentUserId?: number | null;
  othersEventsLocked?: boolean;
}

/**
 * Where the class wizard goes after a successful save. Normally the saved class opens.
 * A series edit goes back to the calendar, and so does a class a user who can't open
 * other instructors' classes saved for a colleague: its page would be locked for them.
 */
export const getClassWizardSavedRoute = ({
  savedEventId,
  appliedToFuture,
  employeeId,
  currentUserId,
  othersEventsLocked,
}: IClassWizardSavedRouteArgs) => {
  if (appliedToFuture) {
    return routePaths.calendar;
  }

  const savedForColleague = !!employeeId && employeeId !== currentUserId;
  if (othersEventsLocked && savedForColleague) {
    return routePaths.calendar;
  }

  return constructPlannerEventHref(savedEventId);
};
